import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ManpowerWorkersApiService, SalaryCard } from '../../../services/manpowerWorkersApi';

/**
 * Active salary card for a worker as-of a date (defaults to today).
 * Returns null when the worker has no salary configured for that date.
 * `enabled` so it only fires when a worker is selected.
 */
export const useWorkerSalary = (
	workerId?: number,
	asOf?: string
): UseQueryResult<SalaryCard | null, Error> => {
	const date = asOf || new Date().toISOString().slice(0, 10);
	return useQuery({
		queryKey: ['manpower', 'workers', 'salary', workerId, date],
		queryFn: async (): Promise<SalaryCard | null> => {
			return ManpowerWorkersApiService.getSalary(workerId as number, date);
		},
		enabled: !!workerId,
		staleTime: 0,
		refetchOnWindowFocus: false,
	});
};
